import imgOutside from '../../assets/buildings/hotel/outside.png';
import imgFireProtection from '../../assets/buildings/hotel/fire-protection.png';
import imgWater from '../../assets/buildings/hotel/water.png';
import imgWasteWater from '../../assets/buildings/hotel/waste-water.png';
import imgHeating from '../../assets/buildings/hotel/heating.png';
import { Building } from '../../interfaces/buildings';
import { TechSector } from '../tech-sector';
import { ProductType } from '../products';
import { activeLanguage } from '../../activeLanguage';
import { isNoBoolean } from '../../components/utils/isNoBoolean';

const hotelConfig: Building = {
    techSectors: [
        activeLanguage.locale.language === 'de' && {
            type: TechSector.WASTE_WATER,
            img: imgWasteWater,
            products: [
                {
                        position: { x: 165, y: 916 },
                    type: ProductType.AMAREX,
                },
                {
                        position: { x: 1096, y: 736 },
                    type: ProductType.AMA_DRAINER_BOX_UNTERFLUR,
                },
                {
                        position: { x: 1361, y: 732 },
                    type: ProductType.AMA_DRAINER_4_5,
                },
                {
                        position: { x: 1466, y: 617 },
                    type: ProductType.LEVELCONTROL_BASIC_2,
                },
                {
                        position: { x: 1599, y: 635 },
                    type: ProductType.COMPACTA,
                },
            ],
        },
        {
            type: TechSector.FIRE_PROTECTION,
            img: imgFireProtection,
            products: [
                {
                        position: { x: 769, y: 923 },
                    type: ProductType.HYADUO_2_D_FL_COMPACT,
                },
                {
                        position: { x: 1009, y: 923 },
                    type: ProductType.ETANORM_FXV,
                },
            ],
        },
        activeLanguage.locale.language === 'de' && {
            type: TechSector.HEATING,
            img: imgHeating,
            products: [
                {
                        position: { x: 293, y: 830 },
                    type: ProductType.BOAX_S_SF,
                },
                {
                        position: { x: 381, y: 797 },
                    type: ProductType.SERIE_2000,
                },
                {
                        position: { x: 515, y: 875 },
                    type: ProductType.ETANORM,
                },
                {
                        position: { x: 615, y: 817 },
                    type: ProductType.BOA_SYSTRONIC_EPIC,
                },
                {
                        position: { x: 815, y: 789 },
                    type: ProductType.BOA_CONTROL_DPR,
                },
                {
                        position: { x: 905, y: 813 },
                    type: ProductType.CALIO_PRO_PLUS_Z,
                },
                {
                        position: { x: 1033, y: 809 },
                    type: ProductType.CALIO_PRO_PLUS,
                },
                {
                        position: { x: 1185, y: 737 },
                    type: ProductType.BOA_CONTROL_SBV,
                },
                {
                        position: { x: 1303, y: 777 },
                    type: ProductType.BOA_RVK,
                },
                {
                        position: { x: 1393, y: 831 },
                    type: ProductType.ETALINE_Z,
                },
                {
                        position: { x: 853, y: 331 },
                    type: ProductType.BOA_CONTROL_PIC,
                }
            ],
        },
        {
            type: TechSector.WATER,
            img: imgWater,
            products: [
                {
                        position: { x: 393, y: 669 },
                    type: ProductType.MOVITEC,
                },
                {
                        position: { x: 458, y: 852 },
                    type: ProductType.SISTO_16_TWA,
                },
                {
                        position: { x: 545, y: 853 },
                    type: ProductType.DELTA_PRIMO_SVP,
                },
                {
                        position: { x: 683, y: 685 },
                    type: ProductType.BOAX_S_SF,
                },
                {
                        position: { x: 802, y: 840 },
                    type: ProductType.BOA_COMPACT_EKB,
                },
                {
                        position: { x: 1749, y: 890 },
                    type: ProductType.UPA,
                },
            ],
        },
    ].filter(isNoBoolean),
    img: imgOutside,
};


export default hotelConfig;
